import * as types from './mutation-types'
import router from '../router'

const errorNetwork = ({commit}) => {
  router.push({name: "error.network"})
}


const emptyAll = ({commit}) => {
  commit('EMPTY_ALL')
}

const init = async ({commit}) => {
  const {
    data: {
      competenciaOpen, competenciaList,
      user, centroCustoList, userList,
      arvoreList, periodoList, anos, meses,
      processoList, indicadorList
    }
  } = await axios.get(`${process.env.API_PATH}/user/initstate`)
  commit(types.SET_ANOS, {anos})
  commit(types.SET_MESES, {meses})
  commit(types.SET_COMPETENCIA_SELECTED, {competenciaOpen})
  commit(types.SET_ANO_SELECTED, {anoSelected: competenciaOpen.ano})
  commit(types.SET_MES_SELECTED, {mesSelected: competenciaOpen.mes})
  commit(types.SET_COMPETENCIA_OPEN, {competenciaOpen})
  commit(types.SET_USER, {user})
  commit(types.SET_COMPETENCIA_LIST, {competenciaList})
  commit(types.SET_CENTRO_CUSTO_LIST, {centroCustoList})
  commit(types.SET_USER_LIST, {userList})
  commit(types.SET_ARVORE_LIST, {arvoreList})
  commit(types.SET_PERIODO_LIST, {periodoList})
  commit(types.SET_PROCESSO_LIST, {processoList})
  commit(types.SET_INDICADOR_LIST, {indicadorList})

}
const refreshProfile = async ({commit}) => {
  const {data} = await axios.get(`${process.env.API_PATH}/user/profile`)
  commit(types.SET_USER, {user: data})
}
const setUser = async ({commit}, user) => {
  commit(types.SET_USER, {user})
}

const setAnoSelected = async ({commit}, anoSelected) => {
  commit(types.SET_ANO_SELECTED, {anoSelected})
}
const setMesSelected = async ({commit}, mesSelected) => {
  commit(types.SET_MES_SELECTED, {mesSelected})
}
const setCompetenciaOpened = async ({commit}) => {
  const {data} = await axios.get(`${process.env.API_PATH}/competencia/abertalean`)
  commit(types.SET_COMPETENCIA_OPEN, {competenciaOpen: data})
}

const setCentroCustoSelected = ({commit}, centroCustoSelected) => {
  commit(types.SET_CENTRO_CUSTO_SELECTED, {centroCustoSelected})
}
const setCompetenciaSelected = ({commit}, competenciaSelected) => {
  commit(types.SET_COMPETENCIA_SELECTED, {competenciaSelected})
}
const setPeriodoSelected = ({commit}, periodoSelected) => {
  commit(types.SET_PERIODO_SELECTED, {periodoSelected})
}
const setFilterUpdateAt = ({commit}, filterUpdatedAt) => {
  commit(types.SET_FILTER_UPDATE_AT, {filterUpdatedAt})
}


export default {
  emptyAll,
  init,
  setCentroCustoSelected,
  setCompetenciaSelected,
  setPeriodoSelected,
  setFilterUpdateAt,
  setCompetenciaOpened,
  setAnoSelected,
  setMesSelected,
  setUser,
  refreshProfile,
  errorNetwork
}



// WEBPACK FOOTER //
// ./src/store/actions.js